<template>
    <TsSection container-class="px-0" id="pdp_related_products" v-if="monetateStore.pdp_similar_item.ids?.length">
        <TsTypography as="h2" variant="h1" append-class="mb-2">
            {{ useTranslation('pdpSimilarIitems', 'Soortgelijke artikelen') }}
        </TsTypography>
        <div class="lg:-mx-1.5" monetate-id="pdp_related_products">
            <TsCarouselCardProduct
                @product-click="monetateStore.trackRecommendationClick(monetateStore.pdp_similar_item, $event)"
                :navigation="!isMobile" data-testid="product-others-carousel"
                :productIds="monetateStore.pdp_similar_item.ids" productContextType="recommended"
                monetate-class="clickRecsBottom" />
        </div>
    </TsSection>
</template>

<script lang="ts" setup>
import MonetateService from "~/services/monetate.service";

const TsCarouselCardProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselCardProduct.vue') 
);

const monetateStore = useMonetateStore();

const { isMobile } = useDevice();
const monetate = new MonetateService();

type Props = {
    productId: string;
};

const props = defineProps<Props>()

onMounted(() => {
  nextTick(() => {
    monetate.productDetailViewEvent(props.productId);

    if (import.meta.client) {
      window.monetateQ = window.monetateQ || [];
      window.monetateQ.push([
        "addProductDetails", [{
          productId: props.productId,
          sku: props.productId
        }]
      ]);
      window.monetateQ.push(["trackEvent", ["viewProduct"]]);
      window.monetateQ.push(["setPageType", 'product']);
      window.monetateQ.push([ "trackData"]);
    }
  });
});

</script>